import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { QueryParamsConst } from '../../../constants/query-params.constants';
import { updateSearchResults } from '../../../hooks/useQueryParams.effect';
import {
  TNewsListingFields,
  TNewsListingFilter,
  TNewsListingItem,
  TNewsListingProps,
} from '../types/newsListing.types';
import { TBaseObj, TImageField } from '../../../types/types';
import { isEmptyObject } from '../../../utils/checkEmptyObject';
import { TSocialMediaBarProps } from '../../@shared/socialMediaBar/types/socialMediaBar.types';

export class NewsListingItemModel {
  private readonly newsItem?: TNewsListingItem;

  constructor(props: TNewsListingItem) {
    this.newsItem = props;
  }

  get desktopImage(): TImageField | undefined {
    return this.newsItem?.Image;
  }

  get mobileImage(): TImageField | undefined {
    return this.newsItem?.MobileImage;
  }

  get tag(): string | undefined {
    return this.newsItem?.tagCategories?.[0]?.name;
  }

  get newsDate(): string | undefined {
    return this.newsItem?.newsDate;
  }

  get title(): string | undefined {
    return this.newsItem?.title;
  }

  get shortDescription(): string | undefined {
    return this.newsItem?.shortDescription;
  }

  get useVideo(): boolean {
    return this.newsItem?.useVideo === '1';
  }

  get video(): string | undefined {
    return this.newsItem?.video;
  }

  get ctaLink(): string | undefined {
    return this.newsItem?.link;
  }
}

export class NewsListingModel {
  private readonly fields?: TNewsListingFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TNewsListingProps) {
    this.fields = props.fields;
    this.rendering = props?.rendering;
  }

  get filters(): TNewsListingFilter[] {
    return this.fields?.apiData?.filters || [];
  }

  get items(): TNewsListingItem[] {
    return this.fields?.apiData?.items || [];
  }

  findFilterByName(filterName: TNewsListingFilter['value']): TNewsListingFilter {
    return this?.filters.find((filter) => filter.value === filterName) || {};
  }

  resetFilter(navigate) {
    updateSearchResults(navigate, {
      [QueryParamsConst.PAGE]: '',
      [QueryParamsConst.YEAR]: '',
      [QueryParamsConst.LINE]: '',
      [QueryParamsConst.TYPE]: '',
      [QueryParamsConst.FILTER1]: '',
    });
  }

  updateQueryByKey(navigate, key, val) {
    const resetPage = key != QueryParamsConst.PAGE;

    const keyValues = resetPage
      ? {
          [QueryParamsConst.PAGE]: '',
          [key]: val || '',
        }
      : {
          [key]: val || '',
        };

    updateSearchResults(navigate, keyValues);
  }

  updateQueryByBulkKeys(navigate, obj: TBaseObj) {
    updateSearchResults(navigate, obj);
  }

  get counter(): number {
    return this.fields?.apiData?.totalSearchResults || 0;
  }

  get contextItemUrl(): string {
    return this.fields?.itemData?.contextItemUrl || '';
  }

  get socialMediaBarProps(): TSocialMediaBarProps | undefined {
    return isEmptyObject(this.fields?.socialMediaBar) ? undefined : this.fields?.socialMediaBar;
  }

  get isUnreleased(): boolean | undefined {
    return !!this.fields?.isComponentUnreleased;
  }

  get defaultCardImage(): TImageField | undefined {
    return this.fields?.itemData?.fields?.defaultCardImage;
  }

  get placeholderImageSrc(): string | undefined {
    return this.fields?.itemData?.thumbnail;
  }
}
